import { g as s } from "./gls-is-bad-request-Cle0tYNF.js";
const _ = 1e3 * 5, l = 1e3 * 60 * 10, u = 1e3 * 60 * 60, n = (e) => (r, t) => r < e && !s(t), E = 1e3 * 3, L = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: _,
        retry: n(1),
        retryDelay: E
      },
      mutations: {
        retry: !1
      }
    }
  }
};
export {
  u as GLS_LONG_QUERY_STALE_TIME,
  l as GLS_MEDIUM_QUERY_STALE_TIME,
  _ as GLS_SHORT_QUERY_STALE_TIME,
  n as glsRetryOnlyServerErrors,
  L as glsVueQueryPluginOptions
};
